import { useMutation } from '@tanstack/react-query';

import { debug } from '../../../shared/lib/general';
import { getFeedbackDataRequest } from '../api/feedback.api';
import { useFeedbackStore } from './useFeedbackStore';

interface CreateFeedbackParams {
    vmId: number;
    orderInfo: {
        wallet_user_id: string | number;
        transaction_id: string | null;
        src?: number;
    };
}

// Side effects live at the hook level so they survive caller unmount —
// per-`mutate()` callbacks are dropped if the calling component unmounts
// (e.g. CompletedScreen → navigate → SmilePage) before the request resolves.
export const useGetFeedbackData = () => {
    const setFeedback = useFeedbackStore((s) => s.setFeedback);
    return useMutation({
        mutationFn: ({ vmId, orderInfo }: CreateFeedbackParams) =>
            getFeedbackDataRequest(vmId, orderInfo),
        onSuccess: (result) => setFeedback(result),
        onError: (error) => debug('getFeedbackData failed', 'error', error),
    });
};
